export default "__VITE_ASSET__efb10be5__"